export interface ExternalSSOEntry {
  EmailPostfix: string[];
}

export type ExternalSSOConfig = { [customerKey: string]: ExternalSSOEntry };

export const EXTERNAL_SSO: ExternalSSOConfig = {
  BYD01: {
    EmailPostfix: ['boydgroup.com', 'gerbercollision.com']
  }
};

export function matchExternalSSO(
  email: string,
  config: ExternalSSOConfig = EXTERNAL_SSO
): boolean {
  if (!email || !config) {
    return false;
  }
  const atIndex = email.lastIndexOf('@');
  if (atIndex < 0 || atIndex === email.length - 1) {
    return false;
  }
  const domain = email.substring(atIndex + 1).toLowerCase();
  return Object.keys(config).some(key => {
    const entry = config[key];
    return (
      entry &&
      entry.EmailPostfix &&
      entry.EmailPostfix.some(
        postfix => !!postfix && postfix.toLowerCase() === domain
      )
    );
  });
}
